import { render, staticRenderFns } from "./KitsBusquedaSimple.vue?vue&type=template&id=5316c663&"
import script from "./KitsBusquedaSimple.vue?vue&type=script&lang=js&"
export * from "./KitsBusquedaSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports